import React, { Fragment } from "react"
import LineGraph from "../LineGraph"
import OverviewCard from "../OverviewCard"
import PropTypes from "prop-types"
import "./LineGraphCard.scss"

const GRADIENTS = [
  ["#ac3a7c", "#c0418b"], // magenta
  ["#00ABE5", "#70DBFF"], // light blue
  ["#4C69D0", "#4782E7"], // dark blue
  ["#ac3a7c", "#c0418b"], // magenta
]

const LineGraphCard = ({ groups, timeRanges, loading, bsrCompliance }) => {
  const content = !loading ? (
    <Fragment>
      <div className="top">
        <p className="semi-bold margin-left-lg">
          {bsrCompliance
            ? "Bedside Shift Report Compliance Over Time"
            : "Nurse Rounding Compliance Over Time"}
        </p>
        <div className="legend margin-right-lg">
          {groups.map(({ legendLabel }, i) => (
            <div className="item" key={i}>
              <span
                className="box"
                style={{
                  background: `linear-gradient(180deg, ${GRADIENTS[i][0]} 0%, ${
                    GRADIENTS[i][1]
                  } 100%)`,
                }}
              />
              <span className="label">{legendLabel}</span>
            </div>
          ))}
        </div>
      </div>

      <LineGraph
        groups={groups.map((group, i) => ({
          ...group,
          gradient: GRADIENTS[i],
        }))}
        timeRanges={timeRanges}
      />
    </Fragment>
  ) : null

  return (
    <div className="LineGraphCard">
      <OverviewCard>{content}</OverviewCard>
    </div>
  )
}

LineGraphCard.propTypes = {
  timeRanges: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  ),
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      legendLabel: PropTypes.string.isRequired,
      hoverLabel: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          compliance: PropTypes.number,
          change: PropTypes.number,
          opportunities: PropTypes.number.isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired
  ),
  loading: PropTypes.bool,
  bsrCompliance: PropTypes.bool,
}

export default LineGraphCard
